export function formatDateMDYWithSeparator(dateString: string, separator: string = "/"): string {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}${separator}${day}${separator}${year}`;
}

export function formatDateMDY(dateString: string, includeWeekDay = false): string {
    const date = new Date(dateString);
    const month = date.toLocaleString("default", { month: "long" });

    if (includeWeekDay) {
        const weekday = date.toLocaleString("en-US", { weekday: "short" });
        return `${weekday}, ${date.getDate()} ${month} ${date.getFullYear()}`; // Monday, July 5 2025
    }

    return `${month} ${date.getDate()}, ${date.getFullYear()}`; // July 5, 2025
}

export function formatDateMY(dateString: string): string {
    const date = new Date(dateString);
    const month = date.toLocaleString("default", { month: "long" });
    const formattedDate = `${month} ${date.getFullYear()}`;
    return formattedDate; // e.g. January, 2025
}

export function getDateText(publishedAt: string | null, updatedAt: string): string {
    if (!publishedAt) {
        return `Updated on ${formatDateMDY(updatedAt)}`;
    }

    const publishedDate = new Date(publishedAt).toLocaleDateString("en-EN");
    const updatedDate = new Date(updatedAt).toLocaleDateString("en-EN");

    if (publishedDate < updatedDate) {
        return `Updated on ${formatDateMDY(updatedAt)}`;
    }

    return `Published on ${formatDateMDY(publishedAt)}`;
}
